import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { Button, Pagination } from "../../ui";
import TableContainer from "../../ui/TableContainer";
import SearchInput from "../../ui/SearchInput";
import { usePublicHoliday } from "./provider";
import { useUtils } from "../../services/utilsProvider";
import { useState } from "react";

const Grid = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  h2 {
    flex-grow: 4;
    margin-top: 0;
  }
  .search {
    flex-grow: 1;
  }
`;

function ListPublicHoliday() {
  const [search, setSearch] = useState("");
  const theme = useTheme();
  const {
    state: { list, status , count, page, perPage },
    fetchList,
    remove,
    dispatch
  } = usePublicHoliday();
  const navigate = useNavigate();
  const { notify } = useUtils();

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  const cols = [
    { name: "holidayName", label: "Holiday Name" },
    {
      name: "countryCode",
      label: "Country Code",
      fn:"country"
    },
    { name: "startDate", fn: 'date', label: "Start Date" },
    { name: "endDate", fn: 'date', label: "End Date" },

    {
      name: "isFixed",
      label: "Fixed",
      fn:"fixed"
    },
    {
      name: "isActive",
      label: "Active",
      fn:"active"
    },
    {
      name: "lastNotificationDate",
      label: "Last Notification Date",
      fn:"date"
    },
  ];

  const handleClick = () => {
    navigate("/publicHoliday/new");
  };

  const handleView = ({id}) => {
    navigate(`/publicHoliday/view/${id}`);
  };

  const handleEdit = (id) => {
    navigate(`/publicHoliday/edit/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      await remove(id);
      notify("Item has been removed");
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddPattern = (id) => {
    navigate(`/attendance-pattern/list/company/${id}`);
  };

  const handleViewHolidays = (id) => {
    navigate(`/holidays/company/${id}`);
  }

  const handleChangePage = (newPage) =>{
    dispatch({ type: "set_page", payload: newPage });
}
  if (!list ) return
  return (
    <>
      <Grid>
        <h2>Public Holiday List</h2>
        <SearchInput onChange={setSearch} value={search} />
        <Button className="small" onClick={handleClick} iconName="invoice">
          New Entry
        </Button>
      </Grid>
      <TableContainer
        empty={list?.length === 0}
        status={status}
        aria-label="PublicHoliday table"
        cols={cols}
        data={list.filter(item => item.holidayName.toLowerCase().includes(search.toLowerCase(), 0))}
        checkbox
        moreOptions={{
          edit: handleEdit,
          delete: handleDelete,
        }}
      />
      <Pagination
        data-testid="pagination"
        count={count}
        page={page}
        rowsPerPage={perPage}
        onPageChange={handleChangePage}
      />
    </>
  );
}

export default ListPublicHoliday;
